'use client';

import React, { useState } from 'react';
import Header from '@/components/Header';
import AdminOverview from './components/AdminOverview';
import AdminUsers from './components/AdminUsers';
import AdminApprovals from './components/AdminApprovals';
import AdminBookings from './components/AdminBookings';
import AdminPayments from './components/AdminPayments';
import AdminReviews from './components/AdminReviews';
import AdminReports from './components/AdminReports';
import AdminReviewsModeration from './components/AdminReviewsModeration';

const navItems = [
  { id: 'overview', label: 'Overview', icon: '📊' },
  { id: 'users', label: 'Users', icon: '👥' },
  { id: 'approvals', label: 'Approvals', icon: '✅' },
  { id: 'bookings', label: 'Bookings', icon: '📅' },
  { id: 'payments', label: 'Payments', icon: '💰' },
  { id: 'reviews', label: 'Reviews', icon: '⭐' },
  { id: 'moderation', label: 'Moderation', icon: '🛡️' },
  { id: 'reports', label: 'Reports', icon: '📈' },
];

export default function AdminDashboardPage() {
  const [activeSection, setActiveSection] = useState('overview');

  const renderSection = () => {
    switch (activeSection) {
      case 'overview': return <AdminOverview />;
      case 'users': return <AdminUsers />;
      case 'approvals': return <AdminApprovals />;
      case 'bookings': return <AdminBookings />;
      case 'payments': return <AdminPayments />;
      case 'reviews': return <AdminReviews />;
      case 'moderation': return <AdminReviewsModeration />;
      case 'reports': return <AdminReports />;
      default: return <AdminOverview />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Dashboard Header */}
          <div className="mb-8 flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                Admin Dashboard
              </h1>
              <p className="text-gray-500 mt-1 text-sm">Platform management and analytics — Ndoto Stays</p>
            </div>
            <div className="flex items-center gap-2 bg-rose-50 border border-rose-200 rounded-full px-4 py-2">
              <div className="w-2 h-2 bg-rose-500 rounded-full animate-pulse" />
              <span className="text-xs font-semibold text-rose-700">Admin Access</span>
            </div>
          </div>

          {/* Tab Navigation */}
          <div className="flex gap-1 bg-white rounded-2xl p-1.5 shadow-sm border border-gray-100 mb-8 overflow-x-auto">
            {navItems?.map((item) => (
              <button
                key={item?.id}
                onClick={() => setActiveSection(item?.id)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap transition-all duration-200 flex-1 justify-center ${
                  activeSection === item?.id
                    ? 'bg-[#4088C6] text-white shadow-sm'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <span>{item?.icon}</span>
                <span>{item?.label}</span>
              </button>
            ))}
          </div>

          {/* Section Content */}
          <div>{renderSection()}</div>
        </div>
      </div>
    </div>
  );
}
